import { useGrammar } from "context/grammarContext";
import React, { useCallback, useMemo } from "react";
import { useDropzone } from "react-dropzone";
import { useAlert } from "../../context/Feedback/alertContext";
import { useUser } from "../../context/userContext";
import { getExistingGrammarNames, generateUniqueName } from "./utils/Support";
import { saveGrammar } from "../../services/saveService";

import constants from "../../constants/Dialogs/ImportConstants/importConstants";

const baseStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "20px",
  borderWidth: 2,
  borderRadius: 2,
  borderColor: "#eeeeee",
  borderStyle: "dashed",
  backgroundColor: "#fafafa",
  color: "#bdbdbd",
  outline: "none",
  transition: "border .24s ease-in-out",
};

const activeStyle = {
  borderColor: "#2196f3",
};

export default function DropzoneGrammar(props) {
  const { setOriginalGrammar, setGrammarName, setGrammarCreatedDate } =
    useGrammar();
  const { language, credential, user, setUser } = useUser();
  const { setAlert } = useAlert();

  const onDropAccepted = useCallback(
    async ([files]) => {
      var reader = new FileReader();
      setOriginalGrammar("");
      setGrammarName(null);
      let contents;

      reader.readAsText(files);

      reader.onload = async function () {
        contents = reader.result;
        const fileNameWithoutExtension = files.name.replace(/\.[^/.]+$/, "");
        const existingNames = getExistingGrammarNames(user);
        const uniqueFileName = generateUniqueName(
          fileNameWithoutExtension,
          existingNames
        );
        const newCreatedDate = new Date().toISOString();

        setGrammarName(uniqueFileName);
        setGrammarCreatedDate(newCreatedDate);

        setOriginalGrammar(contents);
        props.setOpen(false);
        await saveGrammar({
          grammar: contents,
          grammarName: uniqueFileName,
          grammarCreatedDate: newCreatedDate,
          credential,
          user,
          setUser,
          setAlert,
          setGrammarCreatedDate,
          language,
          isAutoSave: true,
        });
      };
    },
    [user]
  );

  const onDropRejected = useCallback(() => {
    setAlert({
      active: true,
      text: constants.labelAlert.invalidFormat[language],
      color: "warning",
      sevarity: "error",
    });
  });

  const { getRootProps, getInputProps, isDragActive, acceptedFiles } =
    useDropzone({ onDropRejected, accept: ".txt", onDropAccepted });

  const acceptedFileItems = acceptedFiles.map((file) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));

  const style = useMemo(() => ({
    ...baseStyle,
    ...(isDragActive ? activeStyle : {}),
  }));

  return (
    <div {...getRootProps({ style })}>
      <input
        {...getInputProps()}
        id="grammar-upload-input"
        name="grammarUpload"
      />
      <p>{props.text}</p>
      <h4>{acceptedFileItems}</h4>
    </div>
  );
}
